import API from "service";

export async function createSubAdminService(payload) {
  const { data } = await API.post("secure/onboarding/subAdmin", payload);
  return data;
}
export async function updateSubAdminStatusService(userId, status) {
  const { data } = await API.put(
    `secure/dashboard/sub-admin/${userId}/status`,
    { status }
  );

  return data;
}

/**
 * Assign Care Homes
 */
export async function assignCareHomesService(
  subAdminId,
  assignments
) {
  const { data } = await API.post(
    `secure/dashboard/sub-admin/${subAdminId}/care-homes`,
    {
      assignments,
    }
  );

  return data;
}

/**
 * Remove Assigned Care Home
 */
export async function removeCareHomeService(
  subAdminId,
  careHomeIds
) {
  const { data } = await API.del(
    `secure/dashboard/sub-admin/${subAdminId}/care-homes`,
    {
      data: {
        careHomeIds,
      },
    }
  );

  return data;
}
export async function getAssignedCareHomesService(
  subAdminId
) {
  const { data } = await API.get(
    `secure/dashboard/sub-admin/${subAdminId}/care-homes`
  );

  return data;
}

export async function switchCareHomeService(careHomeId) {
  const subAdminToken = localStorage.getItem("subAdminToken");
  const config = subAdminToken ? { headers: { Authorization: `Bearer ${subAdminToken}` } } : {};
  const { data } = await API.post(
    `secure/dashboard/sub-admin/switch-care-home`,
    { careHomeId },
    config
  );
  return data;
}

export async function deleteSubAdminService(userId) {
  const { data } = await API.del(
    `secure/dashboard/sub-admin/${userId}`
  );

  return data;
}
export async function getCareHomesForAssignmentService() {
  const { data } = await API.get(
    "/v2/secure/dashboard/carehomes/get-all"
  );

  return data;
}
export async function resendSubAdminInvitationService(userId) {
  const { data } = await API.post(
    `secure/dashboard/sub-admin/${userId}/resend-invitation`
  );
  return data;
}
